export default (client) => {
  return {
    subscribe(email) {
      return client.post(`/saas/newsletter/subscribe/`, { email })
    },
  }
}
